import './TeamPicker.css';

export interface TeamSlotView {
  heroId?: number;
  heroName?: string;
  headUrl?: string;
  contribution?: number;
}

interface TeamPickerProps {
  isAlly: boolean;
  slots: TeamSlotView[];
  onSlotClick: (slotIndex: number) => void;
  onSlotRemove: (slotIndex: number) => void;
  onClearAll: () => void;
}

export function TeamPicker({
  isAlly,
  slots,
  onSlotClick,
  onSlotRemove,
  onClearAll,
}: TeamPickerProps) {
  const teamLabel = isAlly ? '味方チーム' : '敵チーム';
  const teamClass = isAlly ? 'ally-team' : 'enemy-team';
  const contribTitle = isAlly ? '味方推定勝率への貢献（ピック時点）' : '敵推定勝率への貢献（ピック時点）';

  return (
    <div className={`team-picker ${teamClass}`}>
      <div className="team-header">
        <h3 className="team-title">{teamLabel}</h3>
        <button type="button" className="clear-all-btn" onClick={onClearAll}>
          全消去
        </button>
      </div>

      <div className="hero-slots">
        {slots.map((slot, index) => (
          <div key={index} className="slot-container">
            <div
              className={`hero-slot ${slot.heroId ? 'filled' : 'empty'}`}
              onClick={() => !slot.heroId && onSlotClick(index)}
              onKeyDown={e => {
                if (!slot.heroId && (e.key === 'Enter' || e.key === ' ')) {
                  onSlotClick(index);
                }
              }}
              role={slot.heroId ? undefined : 'button'}
              tabIndex={slot.heroId ? undefined : 0}
            >
              {slot.heroId ? (
                <div className="hero-slot-content">
                  <img src={slot.headUrl} alt={slot.heroName} className="hero-image" />
                  {slot.contribution !== undefined && (
                    <div
                      className={`win-rate-badge ${slot.contribution >= 0 ? 'positive' : 'negative'}`}
                      title={contribTitle}
                    >
                      {slot.contribution >= 0 ? '+' : ''}
                      {(slot.contribution * 100).toFixed(1)}%
                    </div>
                  )}
                </div>
              ) : (
                <span className="slot-number">{index + 1}</span>
              )}
            </div>
            {slot.heroId && (
              <button
                type="button"
                className="remove-btn"
                onClick={e => {
                  e.stopPropagation();
                  onSlotRemove(index);
                }}
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
